import { useContext } from "react";
import { CoworkingRuntimeContext } from "./coworking-runtime-provider";

function useCoworkingRuntime() {
  const runtime = useContext(CoworkingRuntimeContext);

  if (!runtime) {
    throw new Error(
      "useCoworkingRuntime must be used within CoworkingRuntimeProvider.",
    );
  }

  return runtime;
}

export { useCoworkingRuntime };
